module.exports = __webpack_public_path__ + "img/promo_logo01.99c57817.png";